export const bizLines = [{
    name: '门票',
    value: 'ticket',
    bizLineId: 2
}, {
    name: '跟团游',
    value: 'gty',
    bizLineId: 3
}, {
    name: '景酒套餐',
    value: 'jiujing',
    bizLineId: 4
}, {
    name: '机酒套餐',
    value: 'jijiu',
    bizLineId: 6
}, {
    name: '旅游用车',
    value: 'chepiao',
    bizLineId: 7
}, {
    name: '实物电商',
    value: 'wenchuang',
    bizLineId: 1
}];

export const dxEnvUrlMap = {
    'qa': 'api.xm.test.sankuai.com',
    'production': 'api.neixin.cn',
    'staging': 'api.st.neixin.cn'
};


// WEBPACK FOOTER //
// ./src/config/common.js